var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81291 12.6023L12.3854 14.806C12.8421 15.0877 13.409 14.6688 13.2735 14.1498L12.2414 10.1965C12.2123 10.0864 12.2157 9.97053 12.2513 9.86224C12.2869 9.75396 12.3531 9.65764 12.4424 9.58437L15.646 6.98827C16.0669 6.64715 15.8496 5.96697 15.3088 5.9328L11.1251 5.66844C11.0124 5.6606 10.9044 5.62175 10.8135 5.55643C10.7226 5.4911 10.6526 5.40197 10.6117 5.29943L9.05139 1.47371C9.00897 1.36487 8.93356 1.27117 8.83516 1.20505C8.73675 1.13893 8.62002 1.10352 8.50046 1.10352C8.3809 1.10352 8.26416 1.13893 8.16576 1.20505C8.06736 1.27117 7.99194 1.36487 7.94953 1.47371L6.38919 5.29943C6.34831 5.40197 6.27835 5.4911 6.18745 5.55643C6.09656 5.62175 5.98848 5.6606 5.87579 5.66844L1.6921 5.9328C1.15128 5.96697 0.934018 6.64715 1.35496 6.98827L4.55856 9.58437C4.64784 9.65764 4.71406 9.75396 4.74962 9.86224C4.78517 9.97053 4.78862 10.0864 4.75955 10.1965L3.80232 13.8627C3.63971 14.4855 4.32008 14.9883 4.86807 14.6502L8.18801 12.6023C8.28138 12.5444 8.38977 12.5137 8.50046 12.5137C8.61114 12.5137 8.71953 12.5444 8.81291 12.6023V12.6023Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.1a8b5eb2a30f1283cf46da664d465183.svg";
export { ForwardRef as ReactComponent };